import { useDispatch, useSelector } from 'react-redux';
import {
  resendActivationEmail,
  userLoadingSelector
} from '../redux/features/user/usersSlice';

export const useResendActivation = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(userLoadingSelector);

  const resendActivation = async (email) => {
    try {
      dispatch(resendActivationEmail(email));
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error?.message || 'Failed to resend activation email'
      };
    }
  };

  return {
    resendActivation,
    isLoading
  };
};
